import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell, Tooltip } from '@components/common';
import TextAvatar from '@components/common/TextAvatar';

import { columnSizes } from '@constants/table';

import styles from './AssetCartRequest.module.scss';

export const getColumns = () => ([
	{
		header: 'Asset ID',
		accessorKey: 'assetId',
		size: columnSizes.size100,
		cell: ({ getValue }: CellContext<any, any>) => {
			const assetId = getValue();

			return (
				<AdaptiveTableCell
					className={styles.assetIdColumnContainer}
					maxTextWidth={70}
					text={assetId}
				/>
			);
		},
	},
	{
		header: 'AO',
		accessorKey: 'assetOwnerName',
		size: columnSizes.size70,
		cell: ({ getValue }: CellContext<any, any>) => {
			const assetOwnerName = getValue();

			return (
				<AdaptiveTableCell
					className={styles.assetOwnerColumnContainer}
					maxTextWidth={70}
					text={assetOwnerName}
				/>
			);
		},
	},
	{
		header: 'Type',
		accessorKey: 'assetType',
		size: columnSizes.size70,
		cell: ({ getValue }: CellContext<any, any>) => {
			const assetType = getValue();
			const avatarId = assetType?.icon?.id;

			return (
				<Tooltip
					content={assetType?.assetTypeName}
					offset={[15, 0]}
					placement='top-end'
				>
					<div className={styles.assetTypeColumnContainer}>
						<TextAvatar
							avatarId={avatarId}
							className={styles.assetTypeContainer}
							fontSize='20px'
							isProfileLogo
							isUnknown={!avatarId}
							size='24px'
						/>
					</div>
				</Tooltip>
			);
		},
	},
]);
